import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../Api';
import { useNotification } from '../../Components/GlobalNotification';
import CustomModal from '../../Components/CustomModal';
import { AuthShell, CheckIcon, PasswordField } from './AuthShell';

export const VacationsLogin = () => {
    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const location = useLocation();
    const [showVerifiedModal, setShowVerifiedModal] = useState(location.state?.verified || false);
    const { ApiData: LoginResponse, loading, error: LoginError, post: submitData } = useAuth('/login');
    const [formData, setFormData] = useState({ email: '', password: '' });

    useEffect(() => {
        document.title = 'Kayifi Vacations — Sign in';
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (formData.email !== '' && formData.password !== '') {
            submitData(formData);
        } else {
            showNotification({ type: 'error', title: 'Error', message: 'Please fill in all required fields' });
        }
    };

    useEffect(() => {
        if (LoginResponse) {
            localStorage.setItem('login', LoginResponse?.data?.access_token);
            localStorage.setItem('username', LoginResponse?.data?.name);

            // Store complete user data for Stripe integration
            const userInfo = {
                name: LoginResponse?.data?.name,
                email: LoginResponse?.data?.email,
                role: LoginResponse?.data?.role,
                access_token: LoginResponse?.data?.access_token,
            };
            localStorage.setItem('userInfo', JSON.stringify(userInfo));

            showNotification({ type: 'success', title: 'Success', message: LoginResponse?.message || 'Login successful!' });
            if (LoginResponse?.data?.access_token) {
                navigate('/dashboard');
            }
        }
    }, [LoginResponse]);

    useEffect(() => {
        if (LoginError) {
            const errorMessage = LoginError?.data?.error || LoginError?.message || 'Login failed. Please try again.';
            showNotification({ type: 'error', title: 'Error', message: errorMessage });
        }
    }, [LoginError]);

    const handleVerifiedModalClose = () => {
        setShowVerifiedModal(false);
        navigate('/login', { replace: true });
    };

    return (
        <>
            <AuthShell>
                <section className="reg-hero">
                    <div className="container reg-wrap">
                        <div className="reg-pitch">
                            <span className="eyebrow">vacations.kayifi.com</span>
                            <h1>Welcome back. <span className="accent">Sign in to Kayifi Vacations.</span></h1>
                            <p>Sign in to manage your listings and keep your property details up to date.</p>
                            <ul className="perks">
                                <li><CheckIcon /><span>View and manage all your own listings in one place</span></li>
                                <li><CheckIcon /><span>Edit, update or remove a listing any time</span></li>
                                <li><CheckIcon /><span>Add new properties from your dashboard</span></li>
                            </ul>
                        </div>

                        <div className="reg-card">
                            <form onSubmit={handleSubmit} noValidate={false}>
                                <h2>Sign In</h2>
                                <p className="lead">Sign in to your account.</p>
                                <div className="field">
                                    <label htmlFor="l-email">Email</label>
                                    <input id="l-email" name="email" type="email" autoComplete="email" placeholder="you@example.com" required
                                        value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                                </div>
                                <PasswordField id="l-pw" value={formData.password} placeholder="Enter your password" autoComplete="current-password" minLength={1}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
                                <button className="btn btn-primary btn-lg" type="submit" disabled={loading} style={{ marginTop: '.5rem' }}>
                                    {loading ? 'Signing In…' : 'Sign In'}
                                </button>
                                <p className="switch">Don't have an account? <Link to="/sign-up">Register</Link></p>
                            </form>
                        </div>
                    </div>
                </section>
            </AuthShell>
            <CustomModal
                show={showVerifiedModal}
                close={handleVerifiedModalClose}
                success
                heading="Thank You for Verification"
                btnTxt="OK"
            />
        </>
    );
};
